import React, { useCallback } from "react";
import {
  Chart,
  CommonSeriesSettings,
  Font,
  Legend,
  Series,
  Title,
  Tooltip,
  Label,
  ArgumentAxis,
} from "devextreme-react/chart";
import _ from "lodash";

const CharBarForPosition = ({ data, title, type }) => {
  const resourcesByPosition = _.map(
    _.countBy(
      data.filter((re) => re.Estado == "Activo"),
      "ProfesionCargo",
    ),
    (val, position) => ({
      position,
      val,
    }),
  );

  // El gráfico de cargos se dibuja como barras horizontales (rotated) para que
  // las etiquetas largas se lean bien. La altura crece ~30px por cargo, y el
  // contenedor se limita con maxHeight + scroll vertical para que no se dispare.
  const isPosition = type != "tasks";
  const chartHeight = isPosition
    ? Math.max(300, resourcesByPosition.length * 30)
    : 300;

  const textForCustomTooltip = (arg) => {
    return {
      text: `${arg.argumentText}
            Cantidad:${arg.valueText}`,
    };
  };

  const formatTooltipRvA = (e) => {
    return {
      text: `${e.argument}\n${e.seriesName}\n (${e.valueText})`,
    };
  };

  const colorPvsA = ["#c5c5c5", "#29b9d0", "#6ab41b"];
  const customizeLabel = useCallback((arg) => {
    return {
      visible: true,
      background: "#ff7c7c",
      customizeText(e) {
        return `${e.value}`;
      },
    };
  }, []);

  return (
    <div
      style={
        isPosition
          ? { maxHeight: "360px", overflowY: "auto", overflowX: "hidden" }
          : undefined
      }
    >
      <Chart
        id="chart"
        height={chartHeight}
        rotated={isPosition}
        dataSource={type == "tasks" ? data : resourcesByPosition}
        customizeLabel={type == "tasks" ? "" : customizeLabel}
        //title={title}

        palette={type == "tasks" ? colorPvsA : "Pastel"}
      >
        <Title
          text={
            type == "tasks"
              ? title
              : `${title} ( cantidad total(${data.filter((re) => re.Estado == "Activo")?.length}) )`
          }
        >
          <Font family="apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji" />
        </Title>
        {type == "tasks" && (
          <CommonSeriesSettings argumentField="resource" type="stackedBar" />
        )}
        {type == "tasks" && (
          <Series valueField="PorIniciar" name="Por Iniciar" />
        )}
        {type == "tasks" && <Series valueField="EnCurso" name="En Progreso" />}
        {type == "tasks" && (
          <Series valueField="terminadas" name="terminadas" />
        )}

        {type == "tasks" ? (
          <Legend
            position="inside"
            horizontalAlignment="right"
            verticalAlignment="top"
            visible={true}
            itemTextPosition="right"
          />
        ) : (
          <Series
            valueField="val" //oranger
            argumentField="position" //
            name="Cantidad"
            type="bar"
            color="#ffaa66"
          />
        )}

        <Legend
          position="inside"
          horizontalAlignment="center"
          verticalAlignment="top"
          visible={true}
          itemTextPosition="right"
        />

        <ArgumentAxis>
          <Label overlappingBehavior="none" />
        </ArgumentAxis>

        <Tooltip
          enabled
          location="center"
          customizeTooltip={
            type == "tasks" ? formatTooltipRvA : textForCustomTooltip
          }
        />
      </Chart>
    </div>
  );
};

export default CharBarForPosition;
